import { isAvailable, FDealType, FOfferType } from '../../../../../../../packages/JsonQuery';
import { IFilterSet, TAllFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.Flat;

export const MIXED_FLAT_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailable(FDealType.Sale, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'roomType',
      'price',
      'withNeighbors',
      'squareMeterArea',
      'undergroundTime',
      'floor',
      'floors',
      'balcony',
      'apartments',
      'constructionYear',
      'renovation',
      'constructionType',
      'ceilingHeight',
      'elevators',
      'urbanBathroom',
      'windows',
      'parking',
      'demolition',
      'flatShare',
      'electronicTrading',
      'offerSeller',
      'saleType',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'roomType',
      'dates',
      'price',
      'onlineBooking',
      'withNeighbors',
      'isOwner',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'apartments',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      'parking',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
